import React from "react";
import {connect} from "react-redux";
import {Button, CircularProgress, Dialog, Typography} from "@material-ui/core";
import {IStore} from "../store/reducers";
import actionTypes from "../store/actionTypes";
import Caract_IMG from "../icons/PNGs/caract_img_tiny.png"
import TextField from "@material-ui/core/TextField";
import axios from "axios";
import config from "../config.json";
import {userService} from "../services/UserService";
import {INotificacion} from "../types";



interface IProps {
    open: boolean
    activarCuenta(callback: boolean): void
    notify(notification: INotificacion): void
}

interface IState {
    email: string
    verificado: boolean
    verificando: boolean
    enviado: boolean
    code: string
    error_code: string
    autenticando: boolean
    autenticado: boolean
}

class ActivarCuenta extends React.Component<IProps, IState>{

    state:IState = {
        email: "",
        verificado: false,
        verificando: false,
        enviado: false,
        code: "",
        error_code: "",
        autenticando: false,
        autenticado: false
    }

    sendEmail = () => {

        this.setState({verificando: true})
        axios.post(
            config.url+'/modificar/usuario',
            {email: this.state.email},
            {auth: {
                    username: `${userService.getUser()}`,
                    password: `${userService.getPass()}`
                }
            })
            .then(() => {
                axios.get(config.url+`/send/code?email=${this.state.email}`)
                    .then((res) => {
                        setTimeout(() => this.setState({
                            verificando: false,
                            enviado: true
                        }), 1500)
                    })
                    .catch((error) => {
                        this.setState({verificando: false})
                        this.props.notify({message: 'Error interno, intentalo más tarde o ponte en contacto con nosotros', variant: 'error'})
                    })
                this.props.notify({message: `E-mail de autenticación enviado a ${this.state.email}`, variant: 'success'})
            })
            .catch(() => {
                this.setState({verificando: false})
                this.props.notify({message: 'Error interno, intentalo más tarde o ponte en contacto con nosotros', variant: 'error'})
            })
    }


    guardarCambios = () => {
        this.setState({autenticando: true})
        axios.get(config.url+`/recuperar/cuenta?email=${this.state.email}&code=${this.state.code}&pass=${userService.getPass()}`)
            .then((res) => {

                this.setState({verificando: true})
                axios.post(
                    config.url+'/modificar/usuario',
                    {confirmado: 1},
                    {auth: {
                            username: `${userService.getUser()}`,
                            password: `${userService.getPass()}`
                        }
                    })
                    .then((res) => {
                        setTimeout(() => this.cambiosGuardados(), 1500)
                    })
                    .catch((error) => {
                        this.props.notify({message: 'Error interno, intentalo más tarde o ponte en contacto con nosotros', variant: 'error'})
                    })
            })
            .catch((error) => {
                this.setState({autenticando: false})
                if (error.response.status === 404) {
                    this.setState({error_code: 'El código no es correcto'})
                } else {
                    this.props.notify({message: 'Error interno, intentalo más tarde o ponte en contacto con nosotros', variant: 'error'})
                }
            })
    }

    cambiosGuardados = () => {
        this.props.notify({message: 'Tu cuenta ha sido activada correctamente!', variant: 'success'})
        this.setState({autenticando: false, autenticado: true})
    }

    render() {
        return (
            <Dialog
                open={this.props.open}
                maxWidth={false}
                PaperProps={{style:
                        {
                            display: 'flex',
                            flexDirection: 'row',
                            justifyContent: "space-between",
                            height: '90vh',
                            width: '70vw',
                        }}}
            >
                <link rel="stylesheet"
                      href="https://fonts.googleapis.com/css?family=Poppins"
                />

                <div
                    style={{
                        display: "flex",
                        flexDirection: "column",
                        marginLeft: 50,
                        marginTop: 70,
                        margin: 50,
                        overflow: "auto",
                        justifyContent: "space-between"
                    }}
                >
                    <div
                        style={{
                            display: "flex",
                            flexDirection: "column"
                        }}
                    >

                        <Typography
                            style={{
                                color: "#4C494B",
                                fontSize: 36,
                                fontFamily: "Poppins",
                                fontWeight: "bold"
                            }}
                        >
                            ¡Bienvenido a CropSense!
                        </Typography>


                        <Typography
                            style={{
                                color: "#4C494B",
                                fontSize: 18,
                                fontFamily: "Poppins",
                                marginTop: 30,
                                marginRight: 40
                            }}
                        >
                            Sólo falta un paso para activar tu cuenta <b>CropSense</b> y poder disfrutar de todos nuestros servicios.
                        </Typography>

                        <Typography
                            style={{
                                color: "#4C494B",
                                fontSize: 18,
                                fontFamily: "Poppins",
                                marginTop: 10,
                                marginRight: 40
                            }}
                        >
                            Introduce tu dirección de correo electrónico para que podamos validar tu identidad. <br/> En la sección de configuración podrás decidir si quieres recibir notificaciones de tus parcelas a este correo.
                        </Typography>

                        <TextField
                            style={{
                                margin: 8,
                                width: 360,
                                fontSize: 18
                            }}
                            inputProps={{style: {fontSize: 18, fontFamily: "Poppins"}}}
                            InputLabelProps={{style: {fontSize: 18, fontFamily: "Poppins"}}}
                            disabled={this.state.enviado}
                            value={this.state.email}
                            label={"Dirección de correo electrónico:"}
                            placeholder={"Usuario"}
                            onChange={(e) => this.setState({email: e.target.value})}
                            onKeyPress={(e) => (e.key === 'Enter') && this.sendEmail()}
                        />

                        {!this.state.enviado &&
                        <Button
                            style={{
                                width: 360,
                                height: 51,
                                backgroundColor: this.state.email.length === 0 || this.state.verificando ? '#ccc' : '#80ED99',
                                borderRadius: 10,
                                fontSize: 20,
                                marginBottom: 25,
                                marginTop: 20
                            }}
                            variant={'contained'}
                            onClick={() => this.sendEmail()}
                            disabled={this.state.email.length === 0 || this.state.verificando}
                        >
                            {this.state.verificando ?
                                <CircularProgress
                                    style={{
                                        height: 50,
                                        width: 50,
                                        color: '#b43333'
                                    }}
                                />
                                :
                                <Typography
                                    style={{
                                        color: "#4C494B",
                                        fontFamily: "Poppins",
                                        fontSize: 20,
                                        fontWeight: "bold",
                                        textTransform: "none"
                                    }}
                                >
                                    Enviar código de verificación
                                </Typography>
                            }
                        </Button>
                        }

                        {this.state.enviado &&
                        <div
                            style={{
                                display: 'flex',
                                flexDirection: 'column'
                            }}
                        >
                            <Typography
                                style={{
                                    color: "#4C494B",
                                    fontSize: 18,
                                    fontFamily: "Poppins",
                                    marginTop: 20,
                                    width: '100%'
                                }}
                            >
                                Te hemos enviado un email a tu correo electrónico para verificar tu identidad.
                                <br/>
                                Por favor, introduce el código que has recibido:
                            </Typography>

                            <TextField
                                style={{
                                    margin: 8,
                                    width: 360,
                                    fontSize: 18
                                }}
                                inputProps={{style: {fontSize: 18, fontFamily: "Poppins"}}}
                                InputLabelProps={{style: {fontSize: 18, fontFamily: "Poppins"}}}
                                value={this.state.code}
                                error={this.state.error_code.length !== 0}
                                label={this.state.error_code.length !== 0 ? this.state.error_code : "Código:"}
                                placeholder={"Código:"}
                                onChange={(e) => {
                                    this.setState({code: e.target.value})
                                    if (this.state.error_code.length !== 0) this.setState({error_code: ""})
                                }}
                                onKeyPress={(e) => this.state.code.length !== 0 && (e.key === 'Enter') && this.guardarCambios()}
                            />

                            {!this.state.autenticado &&
                            <Button
                                style={{
                                    width: 360,
                                    height: 51,
                                    backgroundColor: this.state.code.length !== 0? '#80ED99': '#ccc',
                                    borderRadius: 10,
                                    fontSize: 20,
                                    marginBottom: 25,
                                    marginTop: 20
                                }}
                                variant={'contained'}
                                onClick={() => this.guardarCambios()}
                                disabled={this.state.code.length === 0}
                            >
                                {this.state.autenticando ?
                                    <CircularProgress
                                        style={{
                                            height: 50,
                                            width: 50,
                                            color: '#b43333'
                                        }}
                                    />
                                    :
                                    <Typography
                                        style={{
                                            color: "#4C494B",
                                            fontFamily: "Poppins",
                                            fontSize: 20,
                                            fontWeight: "bold",
                                            textTransform: "none"
                                        }}
                                    >
                                        ¡Activar Cuenta!
                                    </Typography>
                                }

                            </Button>
                            }

                        </div>
                        }

                        {this.state.autenticado &&
                        <div
                            style={{
                                display: 'flex',
                                flexDirection: 'column'
                            }}
                        >
                            <Typography
                                style={{
                                    color: "#4C494B",
                                    fontSize: 18,
                                    fontFamily: "Poppins",
                                    marginTop: 20,
                                    width: '100%'
                                }}
                            >
                                Tu cuenta ha sido autenticada correctamente.
                                <br/>
                                Recuerda que puedes activar nuestro servicio en línea de Telegram buscando @CropSenseBot o simplemente CropSense.
                            </Typography>
                            <Button
                                style={{
                                    width: 360,
                                    height: 51,
                                    backgroundColor: '#80ED99',
                                    borderRadius: 10,
                                    fontSize: 20,
                                    marginBottom: 25,
                                    marginTop: 20
                                }}
                                variant={'contained'}
                                onClick={() => this.props.activarCuenta(false)}
                            >
                                <Typography
                                    style={{
                                        color: "#4C494B",
                                        fontFamily: "Poppins",
                                        fontSize: 20,
                                        fontWeight: "bold",
                                        textTransform: "none"
                                    }}
                                >
                                    ¡Comenzar!
                                </Typography>
                            </Button>
                        </div>
                        }

                    </div>

                    <Button
                        style={{
                            width: 100,
                            height: 30,
                            backgroundColor: '#ed8080',
                            borderRadius: 10,
                            marginBottom: 20
                        }}
                        variant={'contained'}
                        onClick={() => userService.logout()}
                    >
                        <Typography
                            style={{
                                color: "#4C494B",
                                fontFamily: "Poppins",
                                fontSize: 16,
                                fontWeight: "bold",
                                textTransform: "none"
                            }}
                        >
                            Cancelar
                        </Typography>
                    </Button>

                </div>

                <img
                    style={{height: '100%'}}
                    src={Caract_IMG}
                    alt="img"
                />

            </Dialog>
        )
    }
}

const mapStateToProps = (state: IStore) => ({
    open: state.navegacion.dialogs.activar_cuenta
});

const mapDispatchToProps = (dispatch: (action: actionTypes) => void) => ({
    activarCuenta: (callback: boolean) => dispatch({type: 'open-activar-cuenta-dialog', callback}),
    notify: (notification: INotificacion) => dispatch({type: 'notify', notification}),
});

export default connect(mapStateToProps, mapDispatchToProps)(ActivarCuenta);
